"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictiveModelType = exports.VariableDemographic = exports.AnalyticsSubdomain = exports.BenchmarkFilter = exports.DateLevel = exports.AnalyticsDomain = exports.StatisticType = exports.AnalyticsValueType = exports.FipsAreaType = exports.BenchmarkValue = void 0;
var BenchmarkValue;
(function (BenchmarkValue) {
    BenchmarkValue["MUCH_HIGHER"] = "MUCH_HIGHER";
    BenchmarkValue["MORE_FAVORABLE"] = "MORE_FAVORABLE";
    BenchmarkValue["HIGHER"] = "HIGHER";
    BenchmarkValue["SIMILAR"] = "SIMILAR";
    BenchmarkValue["LOWER"] = "LOWER";
    BenchmarkValue["LESS_FAVORABLE"] = "LESS_FAVORABLE";
    BenchmarkValue["MUCH_LOWER"] = "MUCH_LOWER";
})(BenchmarkValue || (exports.BenchmarkValue = BenchmarkValue = {}));
var FipsAreaType;
(function (FipsAreaType) {
    FipsAreaType["PLACE"] = "PLACE";
    FipsAreaType["COUNTY"] = "COUNTY";
    FipsAreaType["STATE"] = "STATE";
    FipsAreaType["MSA"] = "MSA";
    FipsAreaType["COUNTY_SUBDIVISION"] = "COUNTY_SUBDIVISION";
    FipsAreaType["NATION"] = "NATION";
    FipsAreaType["CUSTOM"] = "CUSTOM";
})(FipsAreaType || (exports.FipsAreaType = FipsAreaType = {}));
var AnalyticsValueType;
(function (AnalyticsValueType) {
    AnalyticsValueType["PERCENT"] = "PERCENT";
    AnalyticsValueType["AMOUNT"] = "AMOUNT";
    AnalyticsValueType["CURRENCY"] = "CURRENCY";
})(AnalyticsValueType || (exports.AnalyticsValueType = AnalyticsValueType = {}));
var StatisticType;
(function (StatisticType) {
    StatisticType["INDICATOR"] = "INDICATOR";
    StatisticType["INDEX"] = "INDEX";
    StatisticType["SENTIMENT_VALUE"] = "SENTIMENT_VALUE";
})(StatisticType || (exports.StatisticType = StatisticType = {}));
var AnalyticsDomain;
(function (AnalyticsDomain) {
    AnalyticsDomain["SAFETY"] = "SAFETY";
    AnalyticsDomain["ECONOMY"] = "ECONOMY";
    AnalyticsDomain["MOBILITY"] = "MOBILITY";
    AnalyticsDomain["HEALTH_AND_WELLNESS"] = "HEALTH_AND_WELLNESS";
    AnalyticsDomain["INCLUSIVITY_AND_ENGAGEMENT"] = "INCLUSIVITY_AND_ENGAGEMENT";
    AnalyticsDomain["EDUCATION_ARTS_CULTURE"] = "EDUCATION_ARTS_CULTURE";
    AnalyticsDomain["FINANCE"] = "FINANCE";
    AnalyticsDomain["GOVERNANCE"] = "GOVERNANCE";
    AnalyticsDomain["COMMUNITY_CHARACTERISTICS"] = "COMMUNITY_CHARACTERISTICS";
    AnalyticsDomain["COMMUNITY_LIVABILITY"] = "COMMUNITY_LIVABILITY";
    AnalyticsDomain["COMMUNITY_DESIGN"] = "COMMUNITY_DESIGN";
    AnalyticsDomain["NATURAL_ENVIRONMENT"] = "NATURAL_ENVIRONMENT";
    AnalyticsDomain["PARKS_AND_RECREATION"] = "PARKS_AND_RECREATION";
    AnalyticsDomain["UTILITIES"] = "UTILITIES";
})(AnalyticsDomain || (exports.AnalyticsDomain = AnalyticsDomain = {}));
var DateLevel;
(function (DateLevel) {
    DateLevel["YEAR"] = "YEAR";
    DateLevel["MONTH"] = "MONTH";
})(DateLevel || (exports.DateLevel = DateLevel = {}));
var BenchmarkFilter;
(function (BenchmarkFilter) {
    BenchmarkFilter["DEFAULT"] = "DEFAULT";
    BenchmarkFilter["STATE"] = "STATE";
    BenchmarkFilter["POPULATION"] = "POPULATION";
    BenchmarkFilter["STATE_AND_POP"] = "STATE_AND_POP";
    BenchmarkFilter["SES_DEFAULT"] = "SES_DEFAULT";
    BenchmarkFilter["SES_POPULATION"] = "SES_POPULATION";
    BenchmarkFilter["SES_STATE"] = "SES_STATE";
    BenchmarkFilter["SES_STATE_AND_POP"] = "SES_STATE_AND_POP";
})(BenchmarkFilter || (exports.BenchmarkFilter = BenchmarkFilter = {}));
var AnalyticsSubdomain;
(function (AnalyticsSubdomain) {
    AnalyticsSubdomain["ALTERNATE_MODES"] = "ALTERNATE_MODES";
    AnalyticsSubdomain["ARTS_CULTURE"] = "ARTS_CULTURE";
    AnalyticsSubdomain["AUTO"] = "AUTO";
    AnalyticsSubdomain["BROADBAND"] = "BROADBAND";
    AnalyticsSubdomain["BUSINESS_VITALITY"] = "BUSINESS_VITALITY";
    AnalyticsSubdomain["CLIMATE"] = "CLIMATE";
    AnalyticsSubdomain["COMMUNITY_CHARACTERISTICS"] = "COMMUNITY_CHARACTERISTICS";
    AnalyticsSubdomain["COMMUNITY_CLEANLINESS"] = "COMMUNITY_CLEANLINESS";
    AnalyticsSubdomain["COMMUNITY_LIVABILITY"] = "COMMUNITY_LIVABILITY";
    AnalyticsSubdomain["DIVERSITY_INCLUSION"] = "DIVERSITY_INCLUSION";
    AnalyticsSubdomain["ECONOMY"] = "ECONOMY";
    AnalyticsSubdomain["EDUCATION"] = "EDUCATION";
    AnalyticsSubdomain["EMPLOYMENT"] = "EMPLOYMENT";
    AnalyticsSubdomain["ENGAGEMENT_CIVIC_SOCIAL"] = "ENGAGEMENT_CIVIC_SOCIAL";
    AnalyticsSubdomain["ENVIRONMENTAL_HEALTH"] = "ENVIRONMENTAL_HEALTH";
    AnalyticsSubdomain["EQUITY"] = "EQUITY";
    AnalyticsSubdomain["FEELINGS_OF_SAFETY"] = "FEELINGS_OF_SAFETY";
    AnalyticsSubdomain["FIRE_EMS"] = "FIRE_EMS";
    AnalyticsSubdomain["FOOD_SECURITY"] = "FOOD_SECURITY";
    AnalyticsSubdomain["GOVERNANCE"] = "GOVERNANCE";
    AnalyticsSubdomain["HEALTHCARE"] = "HEALTHCARE";
    AnalyticsSubdomain["HEALTHY_LIFESTYLES"] = "HEALTHY_LIFESTYLES";
    AnalyticsSubdomain["HOUSING"] = "HOUSING";
    AnalyticsSubdomain["INCOME"] = "INCOME";
    AnalyticsSubdomain["LAND_USE"] = "LAND_USE";
    AnalyticsSubdomain["LAW_ENFORCEMENT"] = "LAW_ENFORCEMENT";
    AnalyticsSubdomain["LIBRARIES"] = "LIBRARIES";
    AnalyticsSubdomain["MOBILITY"] = "MOBILITY";
    AnalyticsSubdomain["MENTAL_HEALTH"] = "MENTAL_HEALTH";
    AnalyticsSubdomain["PARKS"] = "PARKS";
    AnalyticsSubdomain["PATHS_AND_TRAILS"] = "PATHS_AND_TRAILS";
    AnalyticsSubdomain["POWER"] = "POWER";
    AnalyticsSubdomain["RECREATION"] = "RECREATION";
    AnalyticsSubdomain["RESIDENT_HEALTH"] = "RESIDENT_HEALTH";
    AnalyticsSubdomain["SAFETY"] = "SAFETY";
    AnalyticsSubdomain["SOLID_WASTE_MANAGEMENT"] = "SOLID_WASTE_MANAGEMENT";
    AnalyticsSubdomain["UTILITIES"] = "UTILITIES";
    AnalyticsSubdomain["WATER_SEWER"] = "WATER_SEWER";
    AnalyticsSubdomain["WELLNESS"] = "WELLNESS";
    AnalyticsSubdomain["AIR_QUALITY"] = "AIR_QUALITY";
    AnalyticsSubdomain["EXPENDITURES"] = "EXPENDITURES";
    AnalyticsSubdomain["REVENUE"] = "REVENUE";
})(AnalyticsSubdomain || (exports.AnalyticsSubdomain = AnalyticsSubdomain = {}));
var VariableDemographic;
(function (VariableDemographic) {
    VariableDemographic["ALL"] = "ALL";
    VariableDemographic["OA"] = "OA";
})(VariableDemographic || (exports.VariableDemographic = VariableDemographic = {}));
var PredictiveModelType;
(function (PredictiveModelType) {
    PredictiveModelType["REAL"] = "REAL";
    PredictiveModelType["AR_PREDICTIVE"] = "AR_PREDICTIVE";
    PredictiveModelType["GPAL_PREDICTIVE"] = "GPAL_PREDICTIVE";
})(PredictiveModelType || (exports.PredictiveModelType = PredictiveModelType = {}));
